module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi6-f453870b0646f80f2f3f54ee2c0637f2.webp";